import { render, staticRenderFns } from "./EatGrape.vue?vue&type=template&id=116989c0&scoped=true"
import script from "./EatGrape.vue?vue&type=script&lang=js"
export * from "./EatGrape.vue?vue&type=script&lang=js"
import style0 from "./EatGrape.vue?vue&type=style&index=0&id=116989c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116989c0",
  null
  
)

export default component.exports